<template>
  <div class="iframe-container"></div>
</template>

<style>
/* @import "https://zoom.gosmart.mn/node_modules/@zoomus/websdk/dist/css/bootstrap.css";
@import "https://zoom.gosmart.mn/node_modules/@zoomus/websdk/dist/css/react-select.css"; */
#wc-content #wc-container-left #wc-footer {
  display: block !important;
  padding: 0 !important;
}
#wc-content #wc-container-left #wc-footer {
  display: block !important;
  padding: 0 !important;
}

#wc-content #wc-container-left #wc-footer > div:last-child {
  margin-top: 0px;
}

.more-button__button,
.audio-option-menu__button {
  height: 100% !important;
  cursor: pointer !important;
  border: none !important;
  background-color: transparent !important;
  border-radius: 0px !important;
  border: none !important;
  max-width: 80px !important;
}
.zoomSidebar-header {
  height: 52px;
  padding: 12px;
  border-bottom: 1px solid #d9dde7;
}
.audio-option-menu {
  height: 100% !important;
}
.more-button__button:hover {
  background-color: #424345 !important;
}
.audio-option-menu__button:hover {
  background-color: #424345 !important;
}
.audio-option-menu__pop-menu {
  text-align: left !important;
  background: rgb(31 31 31) !important;
  left: 50% !important;
  left: 114px !important;
  -webkit-transform: translateX(-50%) !important;
  -ms-transform: translateX(-50%) !important;
  transform: translateX(-50%) !important;
  bottom: 54px !important;
}
.more-button__pop-menu {
  text-align: left;
  background: rgb(31 31 31) !important;
  margin-bottom: 2px !important;
  font-size: 12px;
}
@media (max-width: 768px) {
  .more-button__pop-menu {
    right: 0 !important;
    left: auto !important;
    color: white !important;
  }
  .security-option-menu__pop-menu {
    right: 0 !important;
    left: auto !important;
  }
}

.more-button__pop-menu > li {
  color: #cacaca !important;
  padding: 5px 20px 5px 39px !important;
  position: relative !important;
  font-size: 12px !important;
}
.full-screen-widget__button {
  background: black !important;
  color: white !important;
}
.more-button__pop-menu > li > a:hover {
  color: #ddd !important;
  background: rgba(255, 255, 255, 0.1) !important;
}
.audio-option-menu__pop-menu > li > a {
  color: #999 !important;
  padding: 5px 20px 5px 39px !important;
  position: relative !important;
  font-size: 12px !important;
}
.full-screen-widget__pop-menu {
  left: auto !important;
  right: 0px !important;
  text-align: left !important;
}

.security-option-menu__pop-menu--checked > a::before {
  content: "" !important;
  background-position: -386px -6px !important;
  width: 13px !important;
  height: 12px !important;
  position: absolute !important;
  left: 15px !important;
  top: 9px !important;
}

.security-option-menu__pop-menu > li > a {
  color: #999 !important;
  padding: 5px 20px 5px 39px !important;
  position: relative !important;
  font-size: 13px !important;
}

.security-option-menu__button {
  height: 100% !important;
  cursor: pointer !important;
  float: left !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-orient: vertical !important;
  -webkit-box-direction: normal !important;
  -ms-flex-direction: column !important;
  flex-direction: column !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
  background-color: transparent !important;
  max-width: 160px !important;
  border: none !important;
  border-radius: 0 !important;
  padding: 3px 0 0 0 !important;
}

.sharing-setting-dropdown-menu-container__button {
  height: 100% !important;
  cursor: pointer !important;
  float: left !important;
  background-color: transparent !important;
  width: 20px !important;
  border: none !important;
  border-radius: 0 !important;
}

.participants-header__participants-pop-btn {
  position: absolute !important;
  padding: 0 !important;
  border: none !important;
  width: 16px !important;
  height: 16px !important;
  cursor: pointer !important;
  background: transparent !important;
}
.dropdown-toggle::after {
  display: none !important;
}

.security-option-menu__pop-menu {
  text-align: left !important;
  background: rgba(17, 17, 17, 0.8) !important;

  -webkit-transform: translateX(-50%) !important;
  -ms-transform: translateX(-50%) !important;
  transform: translateX(-50%) !important;
  bottom: 54px !important;
}
.security-option-menu__pop-menu > li > a:hover {
  color: #ddd !important;
  background: rgba(255, 255, 255, 0.1) !important;
}
.audio-option-menu__pop-menu > li > a:hover {
  color: #ddd !important;
  background: rgba(255, 255, 255, 0.1) !important;
}
.more-button__pop-menu > li > a {
  color: #999999 !important;
  padding: 5px 20px 5px 16px !important;
}
.full-screen-widget__pop-menu > li > a {
  color: #dddddd !important;
  padding: 5px 20px 5px 39px !important;
  position: relative !important;
}
.full-screen-widget__pop-menu {
  text-align: left !important;
  background: rgba(17, 17, 17, 0.8) !important;
  font-size: 12px !important;
  left: auto !important;
  right: 0px !important;
  top: 34px !important;
  border: 1px solid #747487 !important;
  border-radius: 4px !important;
}

.full-screen-widget__pop-menu > li > a:hover {
  color: #dddddd !important;
  background: rgba(255, 255, 255, 0.1) !important;
}
</style>
<script>
import { ZoomMtg } from "@zoomus/websdk";
ZoomMtg.setZoomJSLib("https://source.zoom.us/1.9.9/lib", "/av");
ZoomMtg.preLoadWasm();
ZoomMtg.prepareJssdk();
//console.log('checkSystemRequirements');

//console.log(JSON.stringify(ZoomMtg.checkSystemRequirements()));

// var API_KEY = '0MvyjWveRxGDliWVnsRhhA';
// var API_SECRET = 'O0QJgmojqrpUjEZl8RrGBMXCeOgXr7SDRb86';

import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";
// var $ = window.$;
import { mapActions } from "vuex";

export default {
  props: {
    task: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {
      src: "",
      meetConfig: {},
      signature: {},

      nickname: "",
      meetingId: "",
      publicPath: process.env.BASE_URL
    };
  },
  created() {
    // if(this.task.i1==1 || (this.task.i1==2 && this.hasPermission(["learningstudent"]) && !this.hasPermission(["learningteacher", "learningadmin"]))){
    //   //window.open(this.task.taskEn, '_blank')
    //   //window.location.href = this.task.taskEn;
    // } else{
    this.successBefore();

    // Meeting config object
    this.meetConfig = {
      // apiKey: API_KEY,
      // apiSecret: API_SECRET,
      apiKey: this.task.s3,
      apiSecret: this.task.s4,
      meetingNumber: this.task.st1,
      userName: this.$store.state.user.userInfo.fullName,
      passWord: this.task.st2,
      //leaveUrl: "https://zoom.us",
      role: this.hasPermission(["learningadmin", "learningteacher"]) ? 1 : 0
    };

    request({
      api: { method: "POST", url: "zoomconfig/getSignature1" },
      data: {
        apiKey: this.meetConfig.apiKey,
        apiSecret: this.meetConfig.apiSecret,
        meetingNumber: this.meetConfig.meetingNumber,
        role: this.meetConfig.role
      },
      store: this.$store
    }).then(res => {
      //console.log(res);
      if (res != false) {
        this.signature = res.token;
        //console.log(this.$store.state.app.activeGroup.hostPro[0]);
        ZoomMtg.init({
          //debug: true,

          leaveUrl: "https://" + this.$store.state.app.activeGroup.hostPro[0],
          //leaveUrl: '/',
          isSupportAV: true,
          isSupportChat: false,
          //audioPanelAlwaysOpen: false,

          // customize: {
          //   meetingInfo: ['topic', 'host', 'mn', 'pwd', 'telPwd', 'invite', 'participant', 'dc', 'enctype'],
          //   toolbar: {
          //     buttons: [
          //       {
          //         text: 'Custom Button',
          //         className: 'CustomButton',
          //         onClick: () => {
          //           console.log('custom button');
          //         }
          //       }
          //     ]
          //   }
          // },

          success: () => {
            ZoomMtg.join({
              meetingNumber: this.meetConfig.meetingNumber,
              userName: this.$store.state.user.userInfo.fullName,
              signature: this.signature,
              apiKey: this.meetConfig.apiKey,
              userEmail: this.$store.state.user.userInfo.mail,
              passWord: this.meetConfig.passWord,
              success: function() {
                // eslint-disable-next-line
                  //console.log("join meeting success", res);
                //self.successAfter();
              },
              error: function() {
                // eslint-disable-next-line
                  //console.log(res);
              }
            });
          },
          error: function() {
            // eslint-disable-next-line
              //console.log(res);
          }
        });
      }
    });
    //}
  },
  mounted() {
    window.zoomBackDisabled = true;
  },
  methods: {
    ...mapActions(["handleMainLayoutConfig"]),
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    successBefore() {
      // TODO: ene golomt ba engiin uye gesen nuhtsul shalgah
      //window.location.path
      //console.log(this.publicPath+"");
      var element2 = document.createElement("link");
      element2.setAttribute("rel", "stylesheet");
      element2.setAttribute("type", "text/css");
      element2.setAttribute(
        "href",
        this.publicPath + "/assets/css/zoom/css/zoom-bootstrap.css"
      );
      document.getElementsByTagName("body")[0].appendChild(element2);

      var element = document.createElement("link");
      element.setAttribute("rel", "stylesheet");
      element.setAttribute("type", "text/css");
      element.setAttribute(
        "href",
        this.publicPath + "/assets/css/zoom/css/zoom-react-select.css"
      );
      document.getElementsByTagName("body")[0].appendChild(element);

      let _obj = this.$store.state.app.mainLayoutConfig;
      _obj.header = -2;
      this.handleMainLayoutConfig(_obj);
      // console.log($('#zmmtg-dynamic'));
      // var l = $('#zmmtg-dynamic').find('.dropdown-toggle');
      // $('.dropdown-toggle').click(function(){
      //   console.log("dfsdf");
      // });
      // // console.log('l', l);
      // // l.forEach(element => {
      // //   console.log(element);
      // //   element.click(function(){
      // //   console.log('***********************************************');
      // // })
      // // });
    }
  },
  beforeDestroy() {
    ZoomMtg.leaveMeeting({});
  }
};
</script>
